import { gql } from 'graphql-tag';

import { ImageFragments } from './ImageType';

const userId = gql`
  fragment UserId on User {
    _id: externalId
  }
`;

const currentUserId = gql`
  fragment CurrentUserId on CurrentUser {
    _id: externalId
  }
`;

const userAvatar = gql`
  fragment UserAvatar on User {
    avatar(croppingStrategy: CENTER, height: 128, width: 128) {
      height
      width
      ...ImageFields
    }
  }
  ${ImageFragments.imageFields}
`;

const currentUserAvatar = gql`
  fragment CurrentUserAvatar on CurrentUser {
    avatar(croppingStrategy: CENTER, height: 128, width: 128) {
      ...ImageFields
    }
  }
  ${ImageFragments.imageFields}
`;

export const UserFragments = {
  id: userId,
  currentUserId,
  avatar: userAvatar,
  currentUserAvatar,
  postLikerUserFields: gql`
    fragment PostLikerUserFields on User {
      ...UserId
      firstName
      lastName
      nickname
      ...UserAvatar
    }
    ${userId}
    ${userAvatar}
  `,
  profileUserFields: gql`
    fragment ProfileUserFields on User {
      ...UserId
      avatar(croppingStrategy: CENTER, height: 280, width: 280) {
        height
        width
        ...ImageFields
      }
      legacyId: id
      nickname
      firstName
      lastName
      isPremium
      biography
      coverImage(width: 1200) {
        ...ImageFields
      }
      countryCode
      catches {
        totalCount
      }
    }
    ${userId}
    ${ImageFragments.imageFields}
  `,
  currentUserFields: gql`
    fragment CurrentUserFields on CurrentUser {
      ...CurrentUserId
      ...CurrentUserAvatar
      legacyId: id
      createdAt
      isPremium
      isVerified
      firstName
      lastName
      nickname
      countryCode
      lengthUnit
      pressureUnit
      speedUnit
      temperatureUnit
      weightUnit
      premiumEndDate
      privateUuid
      privateFields {
        email
      }
    }
    ${currentUserId}
    ${currentUserAvatar}
  `,
  postEntryUserFields: gql`
    fragment PostEntryUserFields on User {
      ...UserId
      ...UserAvatar
      isPremium
      firstName
      lastName
      createdAt
      nickname
    }
    ${userId}
    ${userAvatar}
  `,
  fishingWaterDetailTopAnglersFields: gql`
    fragment FishingWaterDetailTopAnglersFields on TopAnglersConnection {
      totalCount
      edges {
        node {
          ...UserId
          followedByCurrentUser
          displayIcon(height: 256, width: 256) {
            ...FishingWaterDetailDisplayIconFields
          }
          displayName
          nickname
        }
      }
    }
    ${userId}
    ${ImageFragments.displayIconFields}
  `,
};
